import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { first } from 'rxjs/operators';

@Injectable()
export class VersionCheckService {

  private currentHash = '{{POST_BUILD_ENTERS_HASH_HERE}}';

  constructor(private http: HttpClient) { }

  public initVersionCheck() {
    this.checkVersion();
    setInterval(() => {
      this.checkVersion();
    }, 1000 * 60 * 30);
  }

  private checkVersion() {
    // timestamp these requests to invalidate caches
    this.http.get('assets/version.json' + '?t=' + new Date().getTime())
      .pipe(first())
      .subscribe(
        (response: any) => {
          console.log(response)
          const hash = response.hash;
          const hashChanged = this.hasHashChanged(this.currentHash, hash);

          // If new version, do something
          if (hashChanged) {
            console.log("version has changed");
            // ENTER YOUR CODE TO DO SOMETHING UPON VERSION CHANGE
            location.reload();
          }
          // store the new hash so we wouldn't trigger versionChange again
          // only necessary in case you did not force refresh
          this.currentHash = hash;
        },
        (err) => {
          console.error(err, 'Could not get version');
        }
      );
  }

  /**
   * Checks if hash has changed.
   * This file has the JS hash, if it is a different one than in the version.json
   * we are dealing with version change
   * @param currentHash
   * @param newHash
   * @returns {boolean}
   */
  private hasHashChanged(currentHash, newHash) {
    if (!currentHash || currentHash === '{{POST_BUILD_ENTERS_HASH_HERE}}') {
      return false;
    }

    return currentHash !== newHash;
  }
}